import PropTypes from 'prop-types';

import {
  propTypeFontStyle,
  propTypeFontWight,
  propTypeTextDecoration,
  propTypeTextTransform,
} from './basic';

export const propTypeShape = {
  color: PropTypes.string,
  fontSize: PropTypes.number,
  fontStyle: propTypeFontStyle,
  fontWight: propTypeFontWight,
  textDecoration: propTypeTextDecoration,
  textTransform: propTypeTextTransform,
};

const propTypeStyleTextfieldInner = PropTypes.shape(propTypeShape);

export default propTypeStyleTextfieldInner;
